import React, { useEffect, useRef, useState } from 'react'
import Navbar from '../../componenets/Navbar'
import bgImage from '../../Images/Wm1.jpeg'
import Project_img1 from '../../Images/wm2.jpeg'
import Project_img2 from '../../Images/wm3.jpeg'
import Project_img3 from '../../Images/wm4.jpeg'
import { Link } from 'react-router-dom'
import Footer from '../../componenets/Footer'
import { FiArrowUpRight } from 'react-icons/fi'
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs'
import WOW from "wowjs";
import "animate.css";



const Wellhead = () => {

    
  const scrollRef = useRef(null);

    
  const [leftActive, setLeftActive] = useState(false);

  const scroll = (direction) => {
    const { current } = scrollRef;

    if (direction === "right") {
      setLeftActive(true); // left becomes active
    }

    if (direction === "left") {
      setLeftActive(false); // optional: left goes back to default
    }

    if (current) {
      const scrollAmount = 300;
      current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };



  const images = [
    Project_img1, Project_img2, bgImage, Project_img3
  ];

  useEffect(() => {
    new WOW.WOW({
      live: false
    }).init();
  }, []);

  return (
    <div>
        <Navbar />

    <section
      className="about_who-we-are"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="about_who-we-are-content">
        <p className="about_tag">Services</p>
        <h1>Wellhead Maintenance Services</h1>
      </div>
    </section>

    <section className='border_bottom_div wow animate__animated animate__fadeInUp'>
        <h2>Precision maintenance for safe, reliable, long-lasting wellheads</h2>
    </section>

    <section className="services_detail_text wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
        <p>WellClean delivers comprehensive wellhead maintenance solutions to preserve equipment integrity, enhance reliability, and extend asset life.</p>
        <p>Our services include routine inspections, valve servicing, corrosion control, leak detection, and replacement of critical components.</p>
        <p>We prioritize safety, equipment reliability, and operational excellence to keep wellheads functioning optimally in challenging field environments.</p>
        <Link to="/wellbore_cleaning_service">
          <div className="contactBtn">
            <button className="contact-btn">
                Become a Client
            </button>
            <button className="contact-btn">
                <FiArrowUpRight  size={24}/>
            </button>
          </div>
        </Link>
    </section>

    <div className="project_work wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
    <div className="project_ontrol_btn">
      <button
        className={leftActive ? "active" : ""}
        onClick={() => scroll("left")}
      >
        <BsArrowLeft />
      </button>

      <button className="active" onClick={() => scroll("right")}>
        <BsArrowRight />
      </button>
    </div>
        <div className="project_img_carrier">
           <div className="project_container" ref={scrollRef}>
            {images.map((img, index) => (
                <div className="project_work_items" key={index}>
                <img src={img} alt={`project-${index}`} />
                </div>
            ))}
           </div>
        </div>
    </div>     




    <Footer />

    </div>
  )
}

export default Wellhead